module.exports = __webpack_public_path__ + "assets/img/ab3-bg.bd535d7f.png";